export const adyenDefault = {
  Port: '10108',
  logLevel: 'ERROR',
  logFileName: 'adyen-integration',
  SSLEnable: true,
  SSLKeyPath: 'cert/star_localhost_erply_com.key',
  SSLCertPath: 'cert/star_localhost_erply_com.crt',
  production: true,
  logSentryDuration: 0,
  apiKey: '',
  terminalKeyIdentifier: '',
  terminalKeyPassphrase: '',
  terminalKeyVersion: '',
  region: '',
  terminalId: '',
  terminalIP: '',
  checkTerminalBeforeOperation: '',
  connectionType: '',
};

export const adyenFields = {
  apiKey: {
    id: 'apiKey',
    title: 'API key',
    type: 'text',
    validate: (val) => (val?.toString().length ? null : 'API key is required.'),
  },
  terminalKeyIdentifier: {
    id: 'terminalKeyIdentifier',
    title: 'Terminal Key Identifier',
    type: 'text',
    validate: (val) =>
      val?.toString().length ? null : 'Terminal key identifier is required.',
  },
  terminalKeyPassphrase: {
    id: 'terminalKeyPassphrase',
    title: 'Terminal Key passphrase',
    type: 'text',
    validate: (val) =>
      val?.toString().length ? null : 'Terminal key passphrase is required.',
  },
  terminalKeyVersion: {
    id: 'terminalKeyVersion',
    title: 'Terminal Key Version',
    type: 'text',
    validate: (val) =>
      val?.toString().length ? null : 'Terminal key version is required.',
  },
  region: {
    id: 'region',
    title: 'Region',
    type: 'select',
    options: [
      { name: '', value: '' },
      { name: 'Test', value: 'test' },
      { name: 'Europe', value: 'europe' },
      { name: 'Australia', value: 'australia' },
      { name: 'US', value: 'us' },
    ],
  },
  terminalId: {
    id: 'terminalId',
    title: 'Terminal ID',
    type: 'text',
    validate: (val) =>
      val?.toString().length ? null : 'Terminal ID is required.',
  },
  terminalIP: {
    id: 'terminalIP',
    title: 'Terminal IP',
    type: 'text',
    validate: (val) =>
      val?.toString().length ? null : 'Terminal IP is required.',
  },
  checkTerminalBeforeOperation: {
    id: 'checkTerminalBeforeOperation',
    title: 'Check terminal before operation',
    type: 'checkbox',
  },
  connectionType: {
    id: 'connectionType',
    title: 'ConnectionType',
    type: 'select',
    options: ['', 'Cloud, Local', 'Local, Cloud', 'Cloud', 'Local'],
  },
  usePOSGeneralPrinter: {
    id: 'usePOSGeneralPrinter',
    title: 'Print receipt from POS general printer',
    type: 'checkbox',
  },
};
